import { CheckCircle2, X } from "lucide-react";

import { usePwaInstallState } from "./usePwaInstallState";

// Compact, user-triggered acknowledgement shown when an explicit "Install MedoPilot" entry point
// is clicked while already running standalone. Deliberately not the larger promotional automatic
// guidance card (PwaStatusPrompts) -- there is nothing to install here, just a brief confirmation.
export function AlreadyInstalledNotice() {
  const { showAlreadyInstalledNotice, closeAlreadyInstalledNotice } = usePwaInstallState();

  if (!showAlreadyInstalledNotice) {
    return null;
  }

  return (
    <div
      role="dialog"
      aria-live="polite"
      aria-label="MedoPilot is already installed"
      className="fixed inset-x-4 bottom-5 z-50 mx-auto max-w-sm rounded-2xl border border-border bg-card p-4 text-foreground shadow-soft sm:inset-x-auto sm:right-5"
    >
      <div className="flex items-start gap-3">
        <span className="grid size-9 shrink-0 place-items-center rounded-xl bg-primary/10 text-primary">
          <CheckCircle2 className="size-4" aria-hidden="true" />
        </span>
        <div className="min-w-0 flex-1">
          <p className="text-sm font-semibold text-foreground">MedoPilot is already installed</p>
          <p className="mt-1 text-sm leading-5 text-muted-foreground">You can open it directly from your device.</p>
          <button
            type="button"
            onClick={closeAlreadyInstalledNotice}
            className="mt-3 inline-flex min-h-9 items-center justify-center rounded-full border border-primary/25 px-4 text-sm font-semibold text-primary transition-colors hover:bg-primary/5 focus:outline-none focus:ring-4 focus:ring-primary/20"
          >
            Got it
          </button>
        </div>
        <button
          type="button"
          onClick={closeAlreadyInstalledNotice}
          aria-label="Close already-installed notice"
          className="grid size-8 shrink-0 place-items-center rounded-full text-muted-foreground transition hover:bg-secondary hover:text-foreground focus:outline-none focus:ring-4 focus:ring-primary/20"
        >
          <X className="size-4" aria-hidden="true" />
        </button>
      </div>
    </div>
  );
}
